import { render, staticRenderFns } from "./NewChatNameSection.vue?vue&type=template&id=7218236d&scoped=true&"
import script from "./NewChatNameSection.vue?vue&type=script&lang=js&"
export * from "./NewChatNameSection.vue?vue&type=script&lang=js&"
import style0 from "./NewChatNameSection.vue?vue&type=style&index=0&id=7218236d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218236d",
  null
  
)

export default component.exports